import { cn, withColor } from '@rematter/ui-web';
import type { ThemeColor } from '@rematter/ui-web';
import { format } from 'date-fns';

import type { CalendarEvent } from '../../types/calendarEvent';

interface ModuleEventContentProps {
  event: CalendarEvent;
  color: ThemeColor;
}

export const ModuleEventContent = ({
  event,
  color,
}: ModuleEventContentProps) => {
  const isRange = event.kind === 'range';

  return (
    <div
      className={cn(
        '@ModuleEventContent',
        'flex items-center gap-1.5 overflow-hidden px-1 py-0.5',
        isRange && 'rounded-sm bg-custom-color/15',
      )}
      style={withColor(color)}
    >
      {!isRange && (
        <div className="size-1.5 shrink-0 rounded-full bg-custom-color" />
      )}
      {isRange && (
        <div className="w-0.5 self-stretch rounded-full bg-custom-color" />
      )}
      <span className="truncate text-xs font-medium">{event.title}</span>
      {!event.allDay && (
        <span className="shrink-0 text-[10px] text-neutral/50">
          {format(new Date(event.start), 'h:mm a')}
        </span>
      )}
    </div>
  );
};
